import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { gsap } from 'gsap';
import './NotFound.css';

export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    // GSAP staggered entrance animations
    gsap.fromTo('.notfound-oops',
      { opacity: 0, y: -20 },
      { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' }
    );
    gsap.fromTo('.notfound-code-large',
      { scale: 0.6, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1, ease: 'back.out(1.5)', delay: 0.2 }
    );
    gsap.fromTo('.notfound-text-group > *',
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.8, stagger: 0.15, ease: 'power3.out', delay: 0.4 }
    );
    gsap.fromTo('.notfound-illustration',
      { opacity: 0, scale: 0.8 },
      { opacity: 1, scale: 1, duration: 1.2, ease: 'power2.out', delay: 0.6 }
    );
  }, []);

  return (
    <div className="notfound-layout-wrapper">
      <div className="notfound-layout-container">
        
        {/* Left Column: Hanging Plant Illustration (replaces the upside-down figure) */}
        <div className="notfound-illustration left notfound-illustration-left">
          <svg viewBox="0 0 200 400" width="100%" height="100%" className="hanging-vine-svg">
            {/* Hanging chain/rope */}
            <line x1="100" y1="0" x2="100" y2="150" stroke="#8c6239" strokeWidth="2" strokeDasharray="4,4" />
            
            {/* Pot */}
            <path d="M70,150 L130,150 L120,180 L80,180 Z" fill="#d77a44" />
            <ellipse cx="100" cy="150" rx="30" ry="5" fill="#b05c2a" />
            
            {/* Vines cascading down */}
            <path d="M90,152 Q70,220 85,280 T95,370" fill="none" stroke="#2d7a20" strokeWidth="4" strokeLinecap="round" className="vine-path vine-1" />
            <path d="M100,152 Q120,200 105,260 T115,350" fill="none" stroke="#00B517" strokeWidth="5" strokeLinecap="round" className="vine-path vine-2" />
            <path d="M110,152 Q130,230 115,290 T125,380" fill="none" stroke="#4caf50" strokeWidth="4" strokeLinecap="round" className="vine-path vine-3" />
            
            {/* Leaves on Vine 1 */}
            <path d="M90,180 Q80,185 85,190 T90,195 Z" fill="#2d7a20" />
            <path d="M82,220 Q70,225 78,235 T85,230 Z" fill="#2d7a20" />
            <path d="M85,260 Q95,270 90,280 T80,270 Z" fill="#2d7a20" />
            <path d="M90,310 Q80,320 85,330 T95,320 Z" fill="#2d7a20" />
            
            {/* Leaves on Vine 2 */}
            <path d="M105,180 Q115,185 110,195 T100,190 Z" fill="#00B517" />
            <path d="M112,220 Q125,230 115,240 T105,230 Z" fill="#00B517" />
            <path d="M108,270 Q98,280 102,290 T112,280 Z" fill="#00B517" />
            <path d="M110,320 Q120,335 115,345 T108,335 Z" fill="#00B517" />
            
            {/* Leaves on Vine 3 */}
            <path d="M110,190 Q120,200 115,205 T108,198 Z" fill="#4caf50" />
            <path d="M122,240 Q135,245 128,255 T120,250 Z" fill="#4caf50" />
            <path d="M118,300 Q130,310 122,320 T115,310 Z" fill="#4caf50" />
          </svg>
        </div>

        {/* Center Column: Text & Route triggers */}
        <div className="notfound-center-card">
          <h2 className="notfound-oops">Oops...</h2>
          <div className="notfound-code-large">404</div>
          
          <div className="notfound-text-group">
            <p className="notfound-main-msg">Something happened to this page...</p>
            <p className="notfound-sub-msg">Don't worry, you can always</p>
            
            <div className="notfound-btn-row">
              <button className="notfound-btn-back" onClick={() => navigate(-1)}>
                Go back
              </button>
              <button className="notfound-btn-home" onClick={() => navigate('/')}>
                Go home
              </button>
            </div>
          </div>
        </div>

        {/* Right Column: Dancing Sprout Illustration (replaces the posing figure) */}
        <div className="notfound-illustration right notfound-illustration-right">
          <svg viewBox="0 0 200 400" width="100%" height="100%" className="growing-plant-svg">
            {/* Soil mound */}
            <path d="M50,380 Q100,360 150,380 Z" fill="#8c6239" />
            <ellipse cx="100" cy="380" rx="50" ry="10" fill="#603813" />
            
            {/* Main growing stem */}
            <path d="M100,380 Q90,300 110,240 T90,140" fill="none" stroke="#00B517" strokeWidth="6" strokeLinecap="round" className="growing-stem" />
            
            {/* Branches and leaves */}
            <path d="M102,320 Q130,300 140,280" fill="none" stroke="#2d7a20" strokeWidth="4" strokeLinecap="round" />
            <path d="M140,280 Q150,265 140,260 T125,275 Z" fill="#2d7a20" />
            
            <path d="M96,280 Q70,260 60,230" fill="none" stroke="#2d7a20" strokeWidth="4" strokeLinecap="round" />
            <path d="M60,230 Q50,215 60,210 T75,225 Z" fill="#2d7a20" />
            
            <path d="M108,210 Q140,180 130,150" fill="none" stroke="#4caf50" strokeWidth="3" strokeLinecap="round" />
            <path d="M130,150 Q138,135 125,135 T115,148 Z" fill="#4caf50" />
            
            {/* Top leaf node */}
            <path d="M90,140 Q80,110 100,90 Q120,110 100,130 Z" fill="#8bc34a" className="top-leaf" />
          </svg>
        </div>

      </div>
    </div>
  );
}


